// Lib
import axiosInstance from '../../../lib/axios';

/**
 * Async function to refresh authentication.
 */
export async function refresh(): Promise<string> {
  return (await axiosInstance.post('auth/refresh')).data;
}
